export default __webpack_public_path__ + "static/media/Group1779.f461df9e.svg";